import React from "react";

import { FormControlLabel, Switch } from "@mui/material";
import { ProgressOverlay } from "components/Progress-overlay/ProgressOverlay";
import { useActionHook } from "hooks";
import { useAccountSelector, useDealActions, useDealIdSelector, useDealNullifyCommitmentsSelect } from "store";

export const NullifyUnfundedCommitment: React.FC = () => {
  const { updateDealNullifyCommitmentsAction } = useDealActions();

  const isNullifyCommitments = useDealNullifyCommitmentsSelect();
  const { nullify_unfunded_commitment } = useAccountSelector() || {};
  const dealId = useDealIdSelector();

  const { action, loading } = useActionHook(updateDealNullifyCommitmentsAction);

  if (!nullify_unfunded_commitment) return null;

  return (
    <ProgressOverlay inProgress={loading}>
      <FormControlLabel
        sx={{ marginRight: 0 }}
        labelPlacement="start"
        control={
          <Switch
            checked={isNullifyCommitments}
            onChange={(e) => {
              if (!dealId) return;
              action({ dealId, nullify: e.target.checked });
            }}
          />
        }
        label="Nullify Unfunded Commitment"
      />
    </ProgressOverlay>
  );
};
